import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  Badge,
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  Tooltip,
} from '@material-ui/core'

import NotificationsIcon from '@material-ui/icons/Notifications'
import WarningIcon from '@material-ui/icons/Warning'

import {
  alertsOpen,
  alertsClose,
} from '../../../../../navigation/navigationSlice'
import { addProfileLogEvent } from '../../MyProfile/myProfileSlice'
import {
  focusAlert,
  acknowledgeAlert,
  selectMyAlertsData,
  updateAlertTitle,
  selectMyAlertsTitle,
} from '../MyAlertsSlice'

import AlertGUI from './AlertGUI'
import Modal from '../../../../../CommonComponents/Modal/Modal'
import { trackEvent } from '../../../../../helpers/analytics'

export const MyAlertsAndNotifications = ({
  dispatch,
  isMobile,
  isGuest,
  classes,
  activeAlerts,
  activeNotificationList,
  dialogOpen,
}) => {
  console.log('activeAlerts ', activeAlerts)
  console.log('activeNotificationList ', activeNotificationList)
  if (isGuest) return null
  const handleAlertsClick = () => {
    dispatch(updateAlertTitle('Notification Center'))
    trackEvent(dispatch, {
      eventName: 'uxp_notifications_view',
      module: 'TopAppBar',
      object: 'NotificationsIcon',
      action: 'view',
      actionContext: 'Notifications',
      actionContextValue: 'NotificationCenterOpened',
    })
    if (process.env.REACT_APP_FIREBASE_ON === 'true') {
      dispatch(
        addProfileLogEvent({
          module: 'TopAppBar',
          object: 'TopAppBarButton',
          objectId: 'TopAppBarItem',
          action: 'Click',
          actionContext: 'AlertsIconClick',
          actionContextValue: 'alertsDialogOpen',
          rcpid: localStorage.getItem('rutgersEduRCPID'),
          timestamp: Date.now(),
        }),
      )
    }
    dispatch(alertsOpen())
    if (isMobile) {
      dispatch(focusAlert())
    }
  }

  const handleMyAlertsClick = () => {
    dispatch(updateAlertTitle('Alert Center'))
    dispatch(alertsOpen())
    if (isMobile) {
      dispatch(focusAlert())
    }
  }
  return (
    <>
      {!isGuest && (
        <>
          <Grid item>
            <Tooltip
              title={<Typography variant="subtitle2">Alerts</Typography>}
              placement="top"
              arrow
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="Alerts" // Find what index alerts is and set is as focused widget
                onClick={handleMyAlertsClick}
              >
                <Badge
                  overlap="circular"
                  badgeContent={activeAlerts}
                  color="primary"
                  className={classes.badgeStyle}
                >
                  <WarningIcon className={classes.appBarIcon} />
                </Badge>
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip
              title={<Typography variant="subtitle2">Notifications</Typography>}
              placement="top"
              arrow
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="Notification Alerts" // Find what index alerts is and set is as focused widget
                onClick={handleAlertsClick}
              >
                <Badge
                  overlap="circular"
                  badgeContent={activeNotificationList}
                  classes={{ badge: classes.notifBadge }}
                  className={classes.badgeStyle}
                >
                  <NotificationsIcon className={classes.appBarIcon} />
                </Badge>
              </IconButton>
            </Tooltip>
            <AlertDialog
              open={dialogOpen}
              classes={classes}
              alertTitle="My Notifications"
            />
          </Grid>
        </>
      )}
    </>
  )
}

export function AlertDialog({ open, classes }) {
  const defaultAlert = {
    id: '',
    datePosted: '',
    dateAcknowledged: '',
    from: '',
    title: '',
    message: '',
    active: '',
  }
  const dispatch = useDispatch()
  const widgetData = useSelector(selectMyAlertsData)
  const alertTitle = useSelector(selectMyAlertsTitle)

  const [alert, setAlert] = React.useState(defaultAlert)
  //   React.useEffect(() => {
  //     if (
  //       localStorage.getItem('user') &&
  //       localStorage.getItem('user') !== '"visitor"'
  //     )
  //       dispatch(fetchMyAlerts())
  //   }, [])

  const dialogHandler = (openAlert = defaultAlert, acknowledge = false) => {
    if (acknowledge) {
      dispatch(acknowledgeAlert(alert))
    }
    setAlert(openAlert)
  }
  console.log('widgetData ', widgetData)
  return (
    <Modal
      open={open}
      onCloseDialog={() => dispatch(alertsClose())}
      dialogTitle={alertTitle}
      dialogContent={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <AlertGUI
            classes={classes}
            data={widgetData}
            dialogHandler={dialogHandler}
          />
        </Box>
      }
      dialogActions={
        <Button onClick={() => dispatch(alertsClose())} color="primary">
          Close
        </Button>
      }
      classes={{ paper: classes.mainDialog }}
    ></Modal>
  )
}
